import React, { useState, useEffect } from "react";
import GraphicData from "../components/graphicData/GraphicData";
import "../components/home/home.css";
import getMonthVisits from "../services/getMonth";
import getTodayVisits from "../services/getToday";
import getTotalVisits from "../services/getTotal";
import getWeekVisits from "../services/getWeek";
import Swal from "sweetalert2";
import getSpecificDate from "../services/getSpecific";
import getUserData from "../services/getAllUserData";
import VisitedPages from "./VisitedPages";

const Home = () => {
  const [totalVisitorsEja, setTotalVisitorsEja] = useState([]);
  const [totalVisitorsOpinio, setTotalVisitorsOpinio] = useState([]);
  const [todayVisitorsEja, setTodayVisitorsEja] = useState([]);
  const [todayVisitorsOpinio, setTodayVisitorsOpinio] = useState([]);
  const [weekVisitorsEja, setWeekVisitorsEja] = useState([]);
  const [weekVisitorsOpinio, setWeekVisitorsOpinio] = useState([]);
  const [monthVisitorsEja, setMonthVisitorsEja] = useState([]);
  const [monthVisitorsOpinio, setMonthVisitorsOpinio] = useState([]);
  const [specificDateTotal, setSpecificDateTotal] = useState([]);
  const [specificDateType, setSpecificDateType] = useState("");
  const [specificDate, setSpecificDate] = useState([]);
  const [source, setSource] = useState([]);

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");

  let today = new Date();
  let idUsuario = localStorage.getItem("idUsuario");

  useEffect(() => {
    getAllVisitors();
    getTodayVisitors();
    getWeekVisitors();
    getMonthVisitors();
    getAllUserData(idUsuario);
  }, []);

  function getAllVisitors() {
    getTotalVisits().then((response) => {
      let _respuesta = JSON.parse(response);
      if (_respuesta.response === "success") {
        setTotalVisitorsEja(_respuesta.data.eja[0]["total"]);
        setTotalVisitorsOpinio(_respuesta.data.opinio[0]["total"]);
      }
    });
  }

  function getTodayVisitors() {
    getTodayVisits().then((response) => {
      let _respuesta = JSON.parse(response);
      if (_respuesta.response === "success") {
        if (_respuesta.data.eja[0]["total"] > 0) {
          setTodayVisitorsEja(_respuesta.data.eja[0]["total"]);
        } else {
          setTodayVisitorsEja("empty");
        }

        if (_respuesta.data.opinio[0]["total"] > 0) {
          setTodayVisitorsOpinio(_respuesta.data.opinio[0]["total"]);
        } else {
          setTodayVisitorsOpinio("empty");
        }
      }
    });
  }

  function getWeekVisitors() {
    getWeekVisits().then((response) => {
      let _respuesta = JSON.parse(response);
      if (_respuesta.response === "success") {
        if (_respuesta.data.eja[0]["total"] > 0) {
          setWeekVisitorsEja(_respuesta.data.eja[0]["total"]);
        } else {
          setWeekVisitorsEja("empty");
        }

        if (_respuesta.data.opinio[0]["total"] > 0) {
          setWeekVisitorsOpinio(_respuesta.data.opinio[0]["total"]);
        } else {
          setWeekVisitorsOpinio("empty");
        }
      }
    });
  }

  function getMonthVisitors() {
    getMonthVisits().then((response) => {
      let _respuesta = JSON.parse(response);
      if (_respuesta.response === "success") {
        if (_respuesta.data.eja[0]["total"] > 0) {
          setMonthVisitorsEja(_respuesta.data.eja[0]["total"]);
        } else {
          setMonthVisitorsEja("empty");
        }

        if (_respuesta.data.opinio[0]["total"] > 0) {
          setMonthVisitorsOpinio(_respuesta.data.opinio[0]["total"]);
        } else {
          setMonthVisitorsOpinio("empty");
        }
      }
    });
  }

  function handleSpecificDate(e) {
    e.preventDefault();

    if(!specificDate || source.length === 0) {
      Swal.fire(
        "Campos incompletos",
        "Por favor verifica los filtros.",
        "warning"
      );
    } else {
      let formData = new FormData();

      formData.append('day', specificDate);
      formData.append('sourcePage', source);

      getSpecificDate(formData).then((response) => {
        let _respuesta = JSON.parse(response);

        setSpecificDateTotal(_respuesta.data[source][0]["total"]);
        if(_respuesta.data[source][0]["source_page"] === 'eja'){
          setSpecificDateType('eja');
        } else {
          setSpecificDateType('opinio');
        }
      })
    }
  }

  function getAllUserData(idUsuario) {
    let formData = new FormData();

    formData.append('idUsuario', idUsuario);

    getUserData(formData).then((response) => {
      let _respuesta = JSON.parse(response);

      if(_respuesta.response === "success"){
        setName(_respuesta.data.nombre);
        setLastName(_respuesta.data.apellidos);
      }
    })
  }

  return (
    <div className="container home">
      {!name || !lastName ? <></> : <h2>¡Hola! {name} {lastName}</h2>}
      <div className="row d-flex justify-content-evenly my-5">
        <div className="col-12 home__title">Reporte Total</div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 my-3">
          <GraphicData
            time={"global"}
            type={"opinio"}
            data={totalVisitorsOpinio}
          />
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 my-3">
          <GraphicData time={"global"} type={"eja"} data={totalVisitorsEja} />
        </div>
      </div>
      <hr/>
      <VisitedPages />
      <hr/>
      <div className="row my-5">
        <div className="col-12 home__title">
          Consuta específica
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 my-3 home__specificRequest">
          <form className="home__picker">
            <div className="mb-3">
              <label htmlFor="start">Fecha:</label>
              <input
                type="date"
                id="start"
                name="trip-start"
                defaultValue={today}
                onChange={(e) => setSpecificDate(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="platform">Selecciona la página de interés:</label>
              <select
                name="platform"
                id="type"
                onChange={(e) => setSource(e.target.value)}
              >
                <option>Selecciona una opción</option>
                <option value="eja">Enlace Jurídico Académico</option>
                <option value="opinio">Resvista Opinio Iuris</option>
              </select>
            </div>

            <button type="submit" onClick={handleSpecificDate} className="btn btn-primary login__button">
              Consultar
            </button>
          </form>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 my-3 home__specificGraph">
          {!specificDateTotal ?
          <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="sr-only"></span>
          </div>
        </div>
        :
          <GraphicData
            time={""}
            type={specificDateType}
            data={specificDateTotal}
          />
        }
        </div>
      </div>
      <hr/>
      <div className="row my-5">
        <div className="col-12 home__title">
          Reporte de visitantes Opinio Iuris
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 my-3">
          <GraphicData
            time={"day"}
            type={"opinio"}
            data={todayVisitorsOpinio}
          />
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 my-3">
          <GraphicData
            time={"week"}
            type={"opinio"}
            data={weekVisitorsOpinio}
          />
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 my-3">
          <GraphicData
            time={"month"}
            type={"opinio"}
            data={monthVisitorsOpinio}
          />
        </div>
      </div>
      <hr/>
      <div className="row my-5">
        <div className="col-12 home__title">
          Reporte de visitantes Enlace Jurídico Académico
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 my-3">
          <GraphicData time={"day"} type={"eja"} data={todayVisitorsEja} />
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 my-3">
          <GraphicData time={"week"} type={"eja"} data={weekVisitorsEja} />
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 my-3">
          <GraphicData time={"month"} type={"eja"} data={monthVisitorsEja} />
        </div>
      </div>
    </div>
  );
};

export default Home;
